"use strict";
var NOTIFICATION_LIFETIME = 2000;
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    var notificationTitle = document.createElement("h2");
    var notificationDescription = document.createElement("p");
    notification.classList.add("notification", type);
    notification.style.top = "".concat(posTop, "px");
    notification.style.right = "".concat(posRight, "px");
    notificationTitle.classList.add("title");
    notificationTitle.textContent = title;
    notificationDescription.innerText = description;
    notification.append(notificationTitle, notificationDescription);
    document.body.append(notification);
    setTimeout(function() {
        notification.style.display = "none";
    }, NOTIFICATION_LIFETIME);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.8b588721.js.map
